import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function MatomoRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const url = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;
    window._paq?.push(["setCustomUrl", url]);
    window._paq?.push(["trackPageView"]);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
